import { Button, ButtonProps } from '@/shared';
import { cn } from '@/shared/utils';

type EmptyStateProps = React.PropsWithChildren<{
	icon?: any;
	title: string;
	actions?: ButtonProps[];
	className?: string;
}>;

export function EmptyState({
	icon,
	title,
	actions,
	children,
	className,
}: EmptyStateProps) {
	const Icon = (icon as any) || null;
	return (
		<div
			className={cn(
				'flex min-h-full w-full flex-grow flex-col items-center justify-center',
				className,
			)}
		>
			<div className="flex max-w-lg flex-col items-center justify-center gap-6 px-4 py-5 text-center">
				{Icon && <Icon className="size-16 text-gray-4" />}
				<div className="space-y-2 text-gray-2">
					<h2 className="text-xl font-semibold">{title}</h2>
					<div className="text-large">{children}</div>
				</div>
				{actions?.length && (
					<div className="mt-2 flex flex-row items-center justify-center gap-5">
						{actions?.map((props, key) => <Button key={key} {...props} />)}
					</div>
				)}
			</div>
		</div>
	);
}
